import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  obtenerPHP(type) {
    var param = "&type=" + type
    var url = ConfigAPI.baseURL + "php" + Session.getToken() + param;
    return instance.get(url);
  },
  mostrarPHP(id) {
    var url = ConfigAPI.baseURL + "php/" + id + Session.getToken();
    return instance.get(url);
  },
  agregarPHP(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "php" + Session.getToken();
    return instance.post(url,params);
  },
  editarPHP(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "php/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarPHP(id) {
    var url = ConfigAPI.baseURL + "php/"+ id + Session.getToken();
    return instance.delete(url);
  },   
  obtenerPHPByModule(module_id) {
    var param = "&module_id=" + module_id
    var url = ConfigAPI.baseURL + "php" + Session.getToken() + param;
    return instance.get(url);
  },  

  guardarCodePHP(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "php/code/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },

  guardarBlockedPHP(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "php/blocked/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },  

  obtenerPHPSnippets(type) {
    var param = "&type=" + type
    var url = ConfigAPI.baseURL + "php/snippets/view" + Session.getToken() + param;
    return instance.get(url);    
  },

  eliminarPHPLog(id) {
    var url = ConfigAPI.baseURL + "php/log/id/"+ id + Session.getToken();
    return instance.delete(url);
  },

  agregarPHPBackup(php_id, data) {
    var params = data
    var url = ConfigAPI.baseURL + "php/backup/" + php_id + Session.getToken();
    return instance.post(url,params);
  },

  eliminarPHPBackup(id) {
    var url = ConfigAPI.baseURL + "php/backup/"+ id + Session.getToken();
    return instance.delete(url);
  },

  obtenerModules() {
    var url = ConfigAPI.baseURL + "modules" + Session.getToken();
    return instance.get(url);
  },  
}

export default servicesAPI;
